<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>
    <section class="dp-right">
      <div class="toolbar-filter-bar">
        <el-form :inline="true" :model="filters" class="toolbar-filter-form">
          <div class="toolbar-filter-fields">
            <el-form-item label="评论者">
              <el-select v-model="filters.commenterType" clearable placeholder="全部" class="toolbar-field-w-md">
                <el-option label="教师" :value="1"></el-option>
                <el-option label="家长" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="删除">
              <el-select v-model="filters.isDeleted" clearable placeholder="全部" class="toolbar-field-w-md">
                <el-option label="正常" :value="false"></el-option>
                <el-option label="已删" :value="true"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关键字">
              <el-input v-model="filters.keyword" clearable placeholder="评论/评论者/帖子" class="toolbar-field-w-lg"></el-input>
            </el-form-item>
            <el-form-item label="日期">
              <el-date-picker v-model="filters.dateRange" type="daterange" value-format="yyyy-MM-dd"
                start-placeholder="开始" end-placeholder="结束" class="toolbar-field-w-daterange"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
            </el-form-item>
          </div>
          <div class="toolbar-filter-actions">
            <el-button v-for="item in actionButtonList" :key="item.id || item.Func"
              size="small"
              :type="resolveActionButton(item).type"
              :plain="resolveActionButton(item).plain"
              :icon="resolveActionButton(item).icon"
              :loading="!!item.loading" @click="btnClick(item)">{{ item.name }}</el-button>
          </div>
        </el-form>
      </div>

            <!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
            <div class="tbl-scroll-host">
            <el-table :data="rows" v-loading="listLoading" stripe style="width: 100%;" height="100%"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="45" align="center"></el-table-column>
        <el-table-column label="班级" min-width="100" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.departmentName || scope.row.DepartmentName || "—" }}</template>
        </el-table-column>
        <el-table-column label="所属帖子" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">{{ postSummary(scope.row) }}</template>
        </el-table-column>
        <el-table-column prop="id" label="评论Id" width="100" align="center">
          <template slot-scope="scope">{{ scope.row.id != null ? scope.row.id : scope.row.Id }}</template>
        </el-table-column>
        <el-table-column label="评论者" min-width="120" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ commenterLabel(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="内容" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.content || scope.row.Content }}</template>
        </el-table-column>
        <el-table-column label="父评论" width="100" align="center">
          <template slot-scope="scope">
            {{ parentId(scope.row) || "—" }}
          </template>
        </el-table-column>
        <el-table-column label="时间" width="155" align="center">
          <template slot-scope="scope">{{ formatDateTime(scope.row.createTime || scope.row.CreateTime) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="70" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="isDeletedRow(scope.row) ? 'info' : 'success'">
              {{ isDeletedRow(scope.row) ? "已删" : "正常" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="!isDeletedRow(scope.row)" size="mini" type="danger" @click="deleteCommentRow(scope.row)">删评</el-button>
            <span v-else class="muted-text">已删</span>
          </template>
        </el-table-column>
      </el-table>
            </div>

      <div class="pagination-container">
        <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange"
          :current-page="page" :page-size="pageSize" :total="total"></el-pagination>
      </div>
    </section>
  </section>
</template>

<script>
import DepartmentPane from "../../components/DepartmentPane";
import { getButtonList } from "../../promissionRouter";
import {
  getClassCircleCommentPage,
  deleteClassCircleComment,
  exportClassCircleComments,
  downloadBlobExcel,
  onClassCircleDeptChange,
  clearClassCircleListTable,
  resolveClassCircleActionButton,
  pickMultiRows,
  formatDateTime
} from "@/api/classCircle";

export default {
  components: { DepartmentPane },
  data() {
    return {
      filters: {
        commenterType: null,
        isDeleted: null,
        keyword: "",
        dateRange: null
      },
      actionButtonList: [],
      multipleSelection: [],
      rows: [],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      DepartmentId: 0,
      routePostId: 0
    };
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    const buttonList = getButtonList(this.$route.path, routers);
    this.actionButtonList = buttonList.filter(b => b.Func !== "handleQuery");
    const routePostId = Number(this.$route.query.postId);
    if (routePostId > 0) {
      this.routePostId = routePostId;
    }
  },
  methods: {
    btnClick(item) {
      if (item.Func && typeof this[item.Func] === "function") {
        this[item.Func](item);
      }
    },
    resolveActionButton(item) {
      return resolveClassCircleActionButton(item);
    },
    formatDateTime,
    commenterLabel(row) {
      const type = row.commenterType != null ? row.commenterType : row.CommenterType;
      const name = row.commenterName || row.CommenterName || "";
      return (type === 1 ? "教师" : "家长") + (name ? "：" + name : "");
    },
    parentId(row) {
      const pid = row.parentCommentId != null ? row.parentCommentId : row.ParentCommentId;
      return pid && pid > 0 ? pid : "";
    },
    postSummary(row) {
      const text = row.postTextSummary || row.PostTextSummary;
      if (text) return text;
      const postId = row.postId != null ? row.postId : row.PostId;
      return postId ? "帖子#" + postId : "—";
    },
    isDeletedRow(row) {
      return !!(row.isDeleted || row.IsDeleted);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val || [];
    },
    handleAdd() {
      this.$message.info("评论由用户在 H5 发布，后台不支持新建");
    },
    handleEdit() {
      this.$message.info("评论不支持编辑，请使用删评");
    },
    handleDel() {
      const rows = pickMultiRows(this, "请选择要删除的评论");
      if (!rows) return;
      const activeRows = rows.filter(r => !this.isDeletedRow(r));
      if (!activeRows.length) {
        this.$message.warning("所选评论均已删除");
        return;
      }
      this.$confirm("确认删除选中的 " + activeRows.length + " 条评论？", "删评", { type: "warning" }).then(async () => {
        for (const row of activeRows) {
          const commentId = row.id != null ? row.id : row.Id;
          const res = await deleteClassCircleComment(commentId);
          if (!res.data.success) {
            this.$message.error(res.data.msg || "删除失败");
            return;
          }
        }
        this.$message.success("删除成功");
        this.getList();
      }).catch(() => {});
    },
    treeNodeClick(data) {
      onClassCircleDeptChange(this, data.value);
      this.handleQuery();
    },
    buildQuery() {
      const q = {
        departmentId: this.DepartmentId,
        pageIndex: this.page,
        pageSize: this.pageSize
      };
      if (this.routePostId > 0) {
        q.postId = this.routePostId;
      }
      if (this.filters.commenterType != null && this.filters.commenterType !== "") {
        q.commenterType = this.filters.commenterType;
      }
      if (this.filters.isDeleted != null && this.filters.isDeleted !== "") {
        q.isDeleted = this.filters.isDeleted;
      }
      if (this.filters.keyword) {
        q.keyword = String(this.filters.keyword).trim();
      }
      if (this.filters.dateRange && this.filters.dateRange.length === 2) {
        q.startDate = this.filters.dateRange[0];
        q.endDate = this.filters.dateRange[1];
      }
      return q;
    },
    handleQuery() {
      this.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    async getList() {
      if (!this.DepartmentId) {
        clearClassCircleListTable(this);
        return;
      }
      this.listLoading = true;
      try {
        const res = await getClassCircleCommentPage(this.buildQuery());
        if (res.data.success) {
          this.rows = res.data.response.data || [];
          this.total = res.data.response.dataCount || 0;
        } else {
          clearClassCircleListTable(this);
          this.$message.error(res.data.msg || "查询失败");
        }
      } finally {
        this.listLoading = false;
      }
    },
    deleteCommentRow(row) {
      const commentId = row.id != null ? row.id : row.Id;
      this.$confirm("确认删除该评论？", "删评", { type: "warning" }).then(async () => {
        const res = await deleteClassCircleComment(commentId);
        if (res.data.success) {
          this.$message.success(res.data.msg || "删除成功");
          this.getList();
        } else {
          this.$message.error(res.data.msg || "删除失败");
        }
      }).catch(() => {});
    },
    async exportExcel(item) {
      if (!this.DepartmentId) {
        this.$message.warning("请先选择机构/班级");
        return;
      }
      if (item) item.loading = true;
      try {
        const q = this.buildQuery();
        q.pageIndex = 1;
        q.pageSize = 10000;
        const res = await exportClassCircleComments(q);
        downloadBlobExcel(res, "班级圈评论");
      } catch (e) {
        this.$message.error("导出失败");
      } finally {
        if (item) item.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.pagination-container {
  margin-top: 16px;
  overflow: hidden;
  text-align: right;
}
.muted-text {
  color: #c0c4cc;
}
</style>
